/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  UpgatesAddonInstall200Response,
  UpgatesAddonInstallRequest,
  UpgatesAddonOpen200Response,
  UpgatesAddonOpenRequest,
  UpgatesAddonProvisionProject200Response,
  UpgatesAddonProvisionProjectRequest,
  UpgatesAddonUninstallRequest,
  UpgatesWebhookRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UpgatesAddonInstall200ResponseFromJSON,
    UpgatesAddonInstall200ResponseToJSON,
    UpgatesAddonInstallRequestFromJSON,
    UpgatesAddonInstallRequestToJSON,
    UpgatesAddonOpen200ResponseFromJSON,
    UpgatesAddonOpen200ResponseToJSON,
    UpgatesAddonOpenRequestFromJSON,
    UpgatesAddonOpenRequestToJSON,
    UpgatesAddonProvisionProject200ResponseFromJSON,
    UpgatesAddonProvisionProject200ResponseToJSON,
    UpgatesAddonProvisionProjectRequestFromJSON,
    UpgatesAddonProvisionProjectRequestToJSON,
    UpgatesAddonUninstallRequestFromJSON,
    UpgatesAddonUninstallRequestToJSON,
    UpgatesWebhookRequestFromJSON,
    UpgatesWebhookRequestToJSON,
} from '../models/index';

export interface UpgatesAddonInstallOperationRequest {
    upgatesAddonInstallRequest?: UpgatesAddonInstallRequest;
}

export interface UpgatesAddonOpenOperationRequest {
    upgatesAddonOpenRequest?: UpgatesAddonOpenRequest;
}

export interface UpgatesAddonProvisionProjectOperationRequest {
    upgatesAddonProvisionProjectRequest?: UpgatesAddonProvisionProjectRequest;
}

export interface UpgatesAddonUninstallOperationRequest {
    upgatesAddonUninstallRequest?: UpgatesAddonUninstallRequest;
}

export interface UpgatesAddonVersionRequest {
    upgatesAddonUninstallRequest?: UpgatesAddonUninstallRequest;
}

export interface UpgatesWebhookOperationRequest {
    upgatesWebhookRequest?: UpgatesWebhookRequest;
}

/**
 * 
 */
export class UpgatesApi extends runtime.BaseAPI {

    /**
     * Creates request options for upgatesAddonInstall without sending the request
     */
    async upgatesAddonInstallRequestOpts(requestParameters: UpgatesAddonInstallOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/install`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonInstallRequestToJSON(requestParameters['upgatesAddonInstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonInstallRaw(requestParameters: UpgatesAddonInstallOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonInstall200Response>> {
        const requestOptions = await this.upgatesAddonInstallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonInstall200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonInstall(requestParameters: UpgatesAddonInstallOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonInstall200Response> {
        const response = await this.upgatesAddonInstallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonOpen without sending the request
     */
    async upgatesAddonOpenRequestOpts(requestParameters: UpgatesAddonOpenOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/open`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonOpenRequestToJSON(requestParameters['upgatesAddonOpenRequest']),
        };
    }

    /**
     */
    async upgatesAddonOpenRaw(requestParameters: UpgatesAddonOpenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonOpen200Response>> {
        const requestOptions = await this.upgatesAddonOpenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonOpen200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonOpen(requestParameters: UpgatesAddonOpenOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonOpen200Response> {
        const response = await this.upgatesAddonOpenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonProvisionProject without sending the request
     */
    async upgatesAddonProvisionProjectRequestOpts(requestParameters: UpgatesAddonProvisionProjectOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/provision-project`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonProvisionProjectRequestToJSON(requestParameters['upgatesAddonProvisionProjectRequest']),
        };
    }

    /**
     * Creates or assigns a project to the Upgates addon. If the addon already has a project, does nothing. Called from the UI after login/onboarding.
     */
    async upgatesAddonProvisionProjectRaw(requestParameters: UpgatesAddonProvisionProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonProvisionProject200Response>> {
        const requestOptions = await this.upgatesAddonProvisionProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonProvisionProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Creates or assigns a project to the Upgates addon. If the addon already has a project, does nothing. Called from the UI after login/onboarding.
     */
    async upgatesAddonProvisionProject(requestParameters: UpgatesAddonProvisionProjectOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonProvisionProject200Response> {
        const response = await this.upgatesAddonProvisionProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonUninstall without sending the request
     */
    async upgatesAddonUninstallRequestOpts(requestParameters: UpgatesAddonUninstallOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/uninstall`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonUninstallRequestToJSON(requestParameters['upgatesAddonUninstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonUninstallRaw(requestParameters: UpgatesAddonUninstallOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.upgatesAddonUninstallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upgatesAddonUninstall(requestParameters: UpgatesAddonUninstallOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upgatesAddonUninstallRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for upgatesAddonVersion without sending the request
     */
    async upgatesAddonVersionRequestOpts(requestParameters: UpgatesAddonVersionRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/version`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonUninstallRequestToJSON(requestParameters['upgatesAddonUninstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonVersionRaw(requestParameters: UpgatesAddonVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonInstall200Response>> {
        const requestOptions = await this.upgatesAddonVersionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonInstall200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonVersion(requestParameters: UpgatesAddonVersionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonInstall200Response> {
        const response = await this.upgatesAddonVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesWebhook without sending the request
     */
    async upgatesWebhookRequestOpts(requestParameters: UpgatesWebhookOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/webhook`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesWebhookRequestToJSON(requestParameters['upgatesWebhookRequest']),
        };
    }

    /**
     */
    async upgatesWebhookRaw(requestParameters: UpgatesWebhookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.upgatesWebhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upgatesWebhook(requestParameters: UpgatesWebhookOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upgatesWebhookRaw(requestParameters, initOverrides);
    }

}
